const config = {
    debug: false,
    excludes: <any>[]
};

//TODO: return interface as declaration to developer when using specific event, to know the properties
export interface IFacebookViewContent{
    content_name: string,
    content_ids: string[],
    content_type: string,
    quantity: number
}

export interface IFacebookPurchase{
    value: number,
    currency: string,
    content_type: string,
    contents: Array<IFacebookPurchaseItem>,
    //content_ids: string[]
}

export interface IFacebookPurchaseItem{
    id: string,
    quantity: number
}

//object of known/used types
export const FaceBookPixelEvents = {
    page:{
        viewcontent : 'ViewContent',
    },
    order: {
        addToCart: 'AddToCart',
        purchase: 'Purchase'
    }
};



const standardEvents = [
    'addpaymentinfo', 'addtocart', 'addtowishlist',
    'completeregistration', 'contact', 'customizeproduct',
    'donate',
    'findlocation',
    'initiatecheckout',
    'lead',
    'pageview', 'purchase',
    'schedule', 'search', 'starttrial', 'submitapplication', 'subscribe',
    'viewcontent'
];


//retry is not ready
const _instance = async () : Promise<any> => {
    return await FacebookPixelHelper.initialize();
};

const _isReady = async (retry: number = 0) =>{
    return !!await _instance(); //negate if not defined
}


export default new class FacebookPixel implements FacebookPixelInstance{
    
    
    init(appId: string, email: string): void {
        //this is NOT inteended as the facebook should be initalized 
        //by Google TagManager..
        throw new Error("Method not implemented.");
    }
    
    
    async event(name: string, data: any): Promise<void> {
        if(!await _isReady()) {
            return;
        }
        
        if (config.debug) {
            console.groupCollapsed(`[Vue Facebook Pixel] Track event "${name}"`)
            console.log("With data:", data);
            console.groupEnd()
        }
        
        
        if(!this.isValidEventName(name)) {
            await this.query('trackCustom', name, data);
        }else{
            await this.query('track',name, data);
        }
    }
    
    
    
    private async query(...args: any)  {
        if(!await _isReady()){
            //warning
            return;
        }
        
        if(config.debug){
            //log group..
        }
        
        const fbq = await _instance();
        fbq(...args);
    }
    
    
    private isValidEventName(name: string): boolean{    
        return standardEvents.includes(name.toLowerCase());
    }
    
}


export interface FacebookPixelInstance {
    
    event(name: string, data: any): void;
    init(appId: string, email: string): void;
}




class FacebookPixelHelper{
    
    static _delayMs: number = 200;
    
    static _fbq: any = null;
    
    static delay(ms: number) : Promise<any> {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }
    
    
    static async initialize(retry: number = 0){
        try{
            if(retry > 4){
                if(config.debug){
                    console.warn('facebook pixel - could not load instance after retry: ',retry);
                }
                return null;
            }
            
            const windowObj = <any>window;
            let instance = this._fbq || windowObj.fbq || windowObj.prototype?.fbq;
            if(!instance) //if not defined
            {
                if(config.debug){
                    console.log('try to load facebook pixel, retry attempts: ' +retry);
                }
                await this.delay(this._delayMs);
                instance = await this.initialize(retry+1);
            }
            this._fbq = instance;
            return this._fbq;
        }catch(error){
            console.warn('facebook pixel - could not load instance');
            return null;
        }
    }
}